import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import EdCreateProductComponent from '@/courses/components/ed-create-product/ed-create-product.component.vue';
import { CourseService } from '@/courses/services/courses.service';
import { COURSE_STORE } from '@/courses/store/course.store';
import { TOAST_TYPES } from '@/plugins/ed-toast/values/ed-toast.values';
import { CORE_ROUTES } from '@/core/core.router';
import { COURSE_TEMPLATE_EVENTS } from '@/course-templates/values/course-templates.values';

@Component({
  name: 'create-subject',
  components: {
    EdCreateProduct: EdCreateProductComponent
  }
})
export default class CreateSubjectView extends Vue {

  /* Data */
  public saving: boolean = false;
  public course: any = {};

  /* Computed */
  get courseId(): number {
    return Number(this.$route.params.id);
  }

  get title() {
    if(this.courseId) {
      return `${this.$i18n.t('courses.createCourse.updateCourse', {courseName: this.course.title})}`; 
    } else {
      return this.$i18n.t('courses.createCourse.createCourse');
    }
  }

  /* Methods */
  public save ({formData, uploadedImage}) {
    this.saving = true;
    if(this.courseId) this.updateCourse(formData, this.courseId, uploadedImage?.file)
    else this.createCourse(formData, uploadedImage?.file)
  }

  async createCourse(course, image) {
    try {
      CourseService.createCourse(course, image).then((res: any) => {
        this.$router.push({ 
          name: CORE_ROUTES.COURSE.NAME,
          params: { courseId: res.id, mode: 'edit' } 
        });
      })
    } catch {
      this.$EdToast.create({ 
        msg:  `${this.$t('courses.errors.errorSavingCourse')}`,
        type: TOAST_TYPES.DANGER,
        top: '3rem',
        timeout: 3000
      });
      this.saving = false;
    }
  }

  async updateCourse(course, courseId, image) {
    try {
      CourseService.updateCourse(course, courseId, image).then((res: any) => {
        this.$router.push({ 
          name: CORE_ROUTES.COURSE.NAME,
          params: { courseId: res.id, mode: 'edit' } 
        });
      })
    } catch(err) {
      this.$EdToast.create({ 
        msg:  `${this.$t('courses.errors.errorSavingCourse')}`,
        type: TOAST_TYPES.DANGER,
        top: '3rem',
        timeout: 3000
      });
      this.saving = false;
    }
  }

  /* Hooks */
  created() {
    this.$edEventBus.$on(COURSE_TEMPLATE_EVENTS.SAVE_COURSE_FORM, this.save);
  }

  beforeDestroy() {
    this.$edEventBus.$off(COURSE_TEMPLATE_EVENTS.SAVE_COURSE_FORM);
  }

  /* Watch */
  @Watch('courseId', {immediate: true})
  async getCourse() {
    try {
      if(this.courseId) {
        this.course = await this.$Courses.Store.getCourseEditionA(this.courseId)
      }
    } catch {
      this.$EdToast.create({ 
        msg:  `${this.$t('courses.errors.errorLoadingCourse')}`,
        type: TOAST_TYPES.DANGER,
        top: '3rem',
        timeout: 3000
      });
    }
  }
}
